import { render, staticRenderFns } from "./PercentRange.vue?vue&type=template&id=52c5be89"
import script from "./PercentRange.vue?vue&type=script&lang=js"
export * from "./PercentRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports